import React from "react";

export const WorkList = ({ imgSrc, projectName, demoSrc, codeSrc }) => {
  return (
    <div
      style={{ backgroundImage: `url(${imgSrc})` }}
      className="shadow-work-lg group container rounded-md flex justify-center items-center mx-auto content-div"
    >
      <div className="opacity-0 group-hover:opacity-100">
        <span className="text-2xl font-bold text-white tracking-wider">
          {projectName}
        </span>
        <div className="pt-8 text-center">
          <a href={demoSrc} target="_blank" rel="noreferrer">
            <button className="text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg">
              Demo
            </button>
          </a>
          <a href={codeSrc} target="_blank" rel="noreferrer">
            <button className="text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg">
              Code
            </button>
          </a>
        </div>
      </div>
    </div>
  );
};
